import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import { StyledLink } from './styles/Link';
import { StyledIcon } from './styles/Icon';
import { News } from './styles/News';

function NewsLink({ href, title }) {
  const isExternalURL = !href.startsWith('/');
  const iconName = isExternalURL ? 'arrow-up-right' : 'arrow-right';

  return (
    <StyledLink
      color="black"
      href={href}
    >
      <News>
        <Typography
          variant="paragraph2"
        >
          {title}
        </Typography>
        <StyledIcon
          name={iconName}
          size="small"
        />
      </News>
    </StyledLink>
  );
}

NewsLink.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default memo(NewsLink);
